<template>

    <m-edit1/>

    <m-section-204 v-bind='{...{"image":"https:\/\/api.mixitweb.com\/storage\/assets\/hero2.png"},...{}}' :style='""' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center " >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="text-white " >
                <template #default> ما برای موفقیت شما برنامه داریم!   </template>
                </m-h1></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center mb-4" >
                <template #default>   <m-p v-bind='{...{},...{}}' :style='""' class="text-white col-lg-8 col-md-12 mx-auto" >
                <template #default>انتخاب یک تیم حرفه‌ای برای طراحی وبسایت می‌تواند تفاوتی اساسی در مسیر موفقیت کسب‌وکار شما ایجاد کند. ما با سال‌ها تجربه در طراحی و توسعه وبسایت‌های موفق و متعهد به ارائه بهترین راهکارها، در کنار شما هستیم تا نیازهای شما را به دقت بشناسیم و راه‌حل‌هایی منحصربه‌فرد برایتان ارائه دهیم.

ما به تخصص و تجربه خود اطمینان داریم و این اطمینان را با ارائه مشاوره دقیق، شفاف و هدفمند به شما منتقل می‌کنیم. هر سوال، ابهام یا چالشی که داشته باشید، تیم ما آماده است تا پاسخ‌هایی کاربردی و حرفه‌ای ارائه دهد. اعتماد شما سرمایه ماست و این اعتماد را با تعهد به کیفیت، دقت در کار و پشتیبانی مداوم حفظ خواهیم کرد.

اجازه دهید تجربه ما، مسیر شما را هموارتر کند. برای دریافت مشاوره، همین امروز با ما تماس بگیرید!   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center mb-5" >
                <template #default>   <m-video v-bind='{...{"controls":true,"videoSrc":"https:\/\/api.mixitweb.com\/storage\/videos\/ba20d770d9dafc8c741c27ca535e5ada51151345-720p.mp4","autoplay":false,"muted":false,"loop":false,"poster":null},...{}}' :style='"border-radius: 25px;\nmax-height:360px;"' class=" shadow  img-fluid p-0" ></m-video></template>
                </m-div></template>
                </m-div></template>
                </m-section-204><m-div v-bind='{...{},...{}}' :style='""' class="container mb-4" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"background: #d0f4de;\n\nborder-radius:25px;"' class="container-fluid shadow" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='"\nbackground:#292929;\nbackground-image: url(\"https:\/\/api.rastavisa.com\/storage\/contents\/bgpatern2.png\");\nbackground-repeat: no-repeat;\nbackground-size: cover;\nborder-radius:25px;"' class="row d-flex  justify-content-center align-items-center p-5 \n" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class=" col-md-6 col-12 text-center p-4" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"color: #ffffff  !important;\nshadow"' class="text-white p-2" >
                <template #default>نیاز به مشاوره دارید ؟   </template>
                </m-h1><m-p v-bind='{...{},...{}}' :style='""' class="text-white" >
                <template #default>برای درخواست مشاوره کلیک کنید .   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-md-6 col-12 text-center" >
                <template #default>   <m-modal-1 v-bind='{...{"modalSize":"modal-md","modalButtonText":"\u062f\u0631 \u062e\u0648\u0627\u0633\u062a \u0645\u0634\u0627\u0648\u0631\u0647 "},...{}}' :style='""' class="" >
                <template #default>   <m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-3","formId":1,"redirectToDashboard":true},...{}}' :style='""' class="" ></m-form-single-1></template>
                </m-modal-1></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSection204 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section204'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mVideo from '@moeinmdn/miw-alpha-components/src/package/Tags/Video'; import mModal1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Modal/Modal1'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1';

export default {
    name: 'HomeView',
    components: {mEdit1, mSection204,mDiv,mH1,mP,mVideo,mModal1,mFormSingle1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
